import {
  EDIT_PROFILE_REQUEST,
  EDIT_PROFILE_SUCCESS,
  EDIT_PROFILE_FAILURE,
  CHANGE_PASSWORD_REQUEST,
  CHANGE_PASSWORD_SUCCESS,
  CHANGE_PASSWORD_FAILURE,
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
  VERIFY_TOKEN_REQUEST,
  VERIFY_TOKEN_SUCCESS,
  VERIFY_TOKEN_FAILURE,
  CLEAR_PROFILE_MESSAGES,
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAILURE,
  SEND_EMAIL_REQUEST,
  SEND_EMAIL_SUCCESS,
  SEND_EMAIL_FAILURE
} from '../constants/profileConstants';

// Edit Profile Actions
export const editProfileRequest = (profileData) => ({
  type: EDIT_PROFILE_REQUEST,
  payload: profileData
});

export const editProfileSuccess = (data) => ({
  type: EDIT_PROFILE_SUCCESS,
  payload: data
});

export const editProfileFailure = (error) => ({
  type: EDIT_PROFILE_FAILURE,
  payload: error
});

// Change Password Actions
export const changePasswordRequest = (passwordData) => ({
  type: CHANGE_PASSWORD_REQUEST,
  payload: passwordData
});

export const changePasswordSuccess = (data) => ({
  type: CHANGE_PASSWORD_SUCCESS,
  payload: data
});

export const changePasswordFailure = (error) => ({
  type: CHANGE_PASSWORD_FAILURE,
  payload: error
});

// Verify Email Actions
export const verifyEmailRequest = (emailData) => ({
  type: VERIFY_EMAIL_REQUEST,
  payload: emailData
});

export const verifyEmailSuccess = (data) => ({
  type: VERIFY_EMAIL_SUCCESS,
  payload: data
});

export const verifyEmailFailure = (error) => ({
  type: VERIFY_EMAIL_FAILURE,
  payload: error
});

// Verify Token Actions
export const verifyTokenRequest = (token, email) => ({
  type: VERIFY_TOKEN_REQUEST,
  payload: { token, email }
});

export const verifyTokenSuccess = (data) => ({
  type: VERIFY_TOKEN_SUCCESS,
  payload: data
});

export const verifyTokenFailure = (error) => ({
  type: VERIFY_TOKEN_FAILURE,
  payload: error
});

// Clear Messages
export const clearProfileMessages = () => ({
  type: CLEAR_PROFILE_MESSAGES
});

// get Profile
export const getProfileRequest = (id) => ({
  type: GET_PROFILE_REQUEST,
  payload: id,
});

export const getProfileSuccess = (data) => ({
  type: GET_PROFILE_SUCCESS,
  payload: data,
});

export const getProfileFailure = (error) => ({
  type: GET_PROFILE_FAILURE,
  payload: error,
});

export const sendEmailRequest = (emailData) => ({
  type: SEND_EMAIL_REQUEST,
  payload: emailData,
});

export const sendEmailSuccess = (data) => ({
  type: SEND_EMAIL_SUCCESS,
  payload: data,
});

export const sendEmailFailure = (error) => ({
  type: SEND_EMAIL_FAILURE,
  payload: error,
});